import { SESSION_FEEDBACK, SESSION_FEEDBACK_SUCCESS, SESSION_FEEDBACK_ERROR, SESSION_FEEDBACK_EMPTY } from '../../actions';

const initialState = {
  data: null,
  message: null,
  loading: false,
  success: false,
  error: false,
};

const SessionFeedback = (state = initialState, action) => {
  switch (action.type) {
    case SESSION_FEEDBACK:
      state = {
        ...state,
        // data: null,
        loading: true,
        success: false,
        error: false,
        message: null,
      };
      break;

    case SESSION_FEEDBACK_SUCCESS:
      state = {
        ...state,
        data: action.payload,
        loading: false,
        success: true,
        error: false,
        message: null,
      };
      break;

    case SESSION_FEEDBACK_ERROR:
      state = {
        ...state,
        data: null,
        loading: false,
        success: false,
        error: true,
        message: action.payload,
      };
      break;

    case SESSION_FEEDBACK_EMPTY:
      state = {
        ...initialState,
      };
      break;

    default:
      state = { ...state };
      break;
  }
  return state;
};

export default SessionFeedback;
